import appGlobalScript from '/home/vsts/work/1/s/src/global.ts';
export const globalScripts = appGlobalScript;
